import React, { Component } from 'react';
import PropTypes from 'prop-types';

import StorePicker from '../StorePicker/StorePicker';
import CalEmbed from '../CalEmbed/CalEmbed';

import styles from './ValentinesDayReservations.module.css';

class ValentinesDayReservations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStore: null,
      stores: [
        {
          storeId: "1110",
          storeName: "Baton Rouge",
          address: "128 West Chimes St, Baton Rouge, LA 70802",
          calendarLink: "insomnia-cookies-baton-rouge/valentinesday"
        },
        {
          storeId: "2052",
          storeName: "Brooklyn, NY - Smith St",
          address: "109 Smith St, Brooklyn, NY 11201",
          calendarLink: "insomnia-cookies-brooklyn/valentinesday"
        },
        {
          storeId: "2139",
          storeName: "Cherry Hill, NJ",
          address: "1006 Haddonfield Rd, Cherry Hill, NJ 08002",
          calendarLink: "insomnia-cookies-cherry-hill/valentinesday"
        },
        {
          storeId: "2073",
          storeName: "Chicago, IL - West Side",
          address: "1335 W. Taylor St., Chicago, IL 60607",
          calendarLink: "insomnia-cookies-chicago/valentinesday"
        },
        {
          storeId: "2024",
          storeName: "College Station, TX",
          address: "505 University Drive, College Station, TX 77840",
          calendarLink: "insomnia-cookies-college-station/valentinesday"
        },
        {
          storeId: "19",
          storeName: "Columbia, SC",
          address: "2013 Devine Street, Columbia, SC 29205",
          calendarLink: "insomnia-cookies-columbia/valentinesday"
        },
        {
          storeId: "2033",
          storeName: "CookieLab",
          address: "833 Wharton Street, Philadelphia, PA 19147",
          calendarLink: "insomnia-cookies-cookie-lab/valentinesday"
        },
        {
          storeId: "2056",
          storeName: "Detroit, MI",
          address: "5171 Anthony Wayne Drive, Detroit, MI 48202",
          calendarLink: "insomnia-cookies-detroit/valentinesday"
        },
        {
          storeId: "1235",
          storeName: "Durham, NC",
          address: "1105 West Main Street, Durham, NC 27701",
          calendarLink: "insomnia-cookies-durham/valentinesday"
        },
        {
          storeId: "2221",
          storeName: "Henderson, NV",
          address: "10520 S. Eastern Ave Suite 110, Henderson, NV 89052",
          calendarLink: "insomnia-cookies-henderson/valentinesday"
        },
        {
          storeId: "2107",
          storeName: "Houston, TX Gateway",
          address: "3113 Scott St. Suite B, Houston, TX 77004",
          calendarLink: "insomnia-cookies-houston/valentinesday"
        },
        {
          storeId: "2104",
          storeName: "IWP",
          address: "One South Broad Street, Philadelphia, PA 19107",
          calendarLink: "insomnia-cookies-iwp/valentinesday"
        },
        {
          storeId: "1089",
          storeName: "Knoxville, TN",
          address: "2121 Cumberland Ave, Suite 103, Knoxville, TN 37916",
          calendarLink: "insomnia-cookies-knoxville/valentinesday"
        },
        {
          storeId: "1119",
          storeName: "Midtown, Atlanta, GA",
          address: "930 Spring Street NW, Atlanta, GA 30309",
          calendarLink: "insomnia-cookies-atlanta/valentinesday"
        },
        {
          storeId: "2191",
          storeName: "Ottawa, CA",
          address: "142 Fifth Ave Unit 105, Ottawa, ON K1S 3W3",
          calendarLink: "insomnia-cookies-ottawa/valentinesday"
        },
        {
          storeId: "2133",
          storeName: "San Antonio, TX - Gardendale",
          address: "4316 Gardendale, San Antonio, TX 78240",
          calendarLink: "insomnia-cookies-san-antonio/valentinesday"
        },
        {
          storeId: "2012",
          storeName: "South Miami, FL",
          address: "6620 SW 57th Avenue, South Miami, FL 33143",
          calendarLink: "insomnia-cookies-south-miami/valentinesday"
        },
        {
          storeId: "2042",
          storeName: "USC Village, CA",
          address: "929 W. Jefferson St., Suite 1620, Los Angeles, CA, 90089",
          calendarLink: "insomnia-cookies-usc-village/valentinesday"
        },
        {
          storeId: "2166",
          storeName: "Wynwood, FL",
          address: "180 NW 25th Street, Suite 160, Miami, FL 33127",
          calendarLink: "insomnia-cookies-wynwood/valentinesday"
        },
        {
          storeId: "2067",
          storeName: "Richardson, TX",
          address: "3000 Northside Boulevard, Suite 300, Richardson, TX, 75080",
          calendarLink: "insomnia-cookies-richardson/valentinesday"
        }
      ]
    };
  }

  render() {
    const { selectedStore, stores } = this.state;
    const {
      useRecaptcha,
      setVerificationToken,
      setVerificationAction,
      setVerificationProvider,
      userOrderMethod,
      location
    } = this.props;

    return (
      <div className={styles.responsiveLayout}>
        {/* Store Picker - takes full width on mobile, 50% on desktop */}
        <div className={styles.storePickerContainer}>
          <StorePicker
            filteredStores={stores}
            selectedStoreId={selectedStore ? selectedStore.storeId : null}
            onSelectStore={(store) => {
              this.setState({ selectedStore: store });
            }}
            useRecaptcha={useRecaptcha}
            setVerificationToken={setVerificationToken}
            setVerificationAction={setVerificationAction}
            setVerificationProvider={setVerificationProvider}
            userOrderMethod={userOrderMethod}
            location={location}
          />
        </div>

        {/* Calendar - takes full width on mobile, 50% on desktop */}
        <div className={styles.calendarContainer}>
          {selectedStore ? (
            <div className={styles.calendarEmbed}>
              <CalEmbed calLink={selectedStore.calendarLink} />
            </div>
          ) : (
            <div className={styles.calendarPlaceholder} />
          )}
        </div>
      </div>
    );
  }
}

ValentinesDayReservations.propTypes = {
  useRecaptcha: PropTypes.bool,
  setVerificationToken: PropTypes.func,
  setVerificationAction: PropTypes.func,
  setVerificationProvider: PropTypes.func,
  userOrderMethod: PropTypes.string,
  location: PropTypes.shape({})
};

ValentinesDayReservations.defaultProps = {
  useRecaptcha: false,
  setVerificationToken: () => {},
  setVerificationAction: () => {},
  setVerificationProvider: () => {},
  userOrderMethod: '',
  location: {}
};

export default ValentinesDayReservations;